module.exports = __webpack_public_path__ + "static/media/new-york-39.a9a91c45.jpg";